<template>
  <base-nav
    v-model="showMenu"
    class="navbar-absolute top-navbar"
    type="white"
    :transparent="true"
  >
    <div slot="brand" class="navbar-wrapper">
      <div class="navbar-minimize d-inline"><sidebar-toggle-button /></div>
      <div
        class="navbar-toggle d-inline"
        :class="{ toggled: $sidebar.showSidebar }"
      >
        <button type="button" class="navbar-toggler" @click="toggleSidebar">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </button>
      </div>
      <a class="navbar-brand" href="#pablo">{{ routeName }}</a>
    </div>

    <ul class="navbar-nav" :class="$rtl.isRTL ? 'mr-auto' : 'ml-auto'">
      <base-dropdown
        tag="li"
        :menu-on-right="!$rtl.isRTL"
        title-tag="a"
        class="nav-item"
        title-classes="nav-link"
        menu-classes="dropdown-navbar"
      >
        <template slot="title">
          <div class="input-group">
            <button class="btn btn-link">
              <i class="fa fa-euro-sign" v-if="mode === 'pea'"></i>
              <i class="fa fa-dollar-sign" v-if="mode === 'usa'"></i>
              <i class="" v-if="mode === 'crypto'">₿</i>
              <span class="new-badge bg-primary">NEW</span>
              <br />
              <small>Changer de compte</small>
            </button>
          </div>
        </template>

        <li class="nav-link" v-if="mode !== 'crypto'">
          <a
            href="#"
            @click="changeMode('crypto')"
            class="nav-item dropdown-item"
          >
            <i class="mr-3 text-primary bold">₿</i>Basculer sur le compte
            Crypto</a
          >
        </li>
        <li class="nav-link" v-if="mode !== 'pea'">
          <a href="#" @click="changeMode('pea')" class="nav-item dropdown-item">
            <i class="fa fa-euro-sign mr-3 text-primary"></i>Basculer sur le
            compte PEA</a
          >
        </li>
        <li class="nav-link" v-if="mode !== 'usa'">
          <a href="#" @click="changeMode('usa')" class="nav-item dropdown-item">
            <i class="fa fa-dollar-sign mr-3 text-primary"></i>Basculer sur le
            compte US</a
          >
        </li>
      </base-dropdown>

      <router-link
        class="input-group"
        tag="div"
        to="/pages/user"
        v-if="mode !== 'crypto'"
      >
        <button class="btn btn-link" v-if="filterEnable">
          <i class="fas fa-filter"></i><br />
          <small>Filtres actifs</small>
        </button>
      </router-link>
      <!-- <div class="search-bar input-group" @click="searchModalVisible = true">
        <button
          class="btn btn-link"
          id="search-button"
          data-toggle="modal"
          data-target="#searchModal"
        >
          <i class="tim-icons icon-zoom-split"></i>
        </button>
      </div> -->
      <router-link
        class="input-group d-inline-block d-md-none"
        tag="div"
        to="/pages/user"
      >
        <button class="btn btn-link">
          <i class="tim-icons icon-single-02 mr-3"></i><br />
          <small>Profil</small>
        </button>
      </router-link>
      <!-- <modal
        :show.sync="searchModalVisible"
        class="modal-search"
        id="searchModal"
        :centered="false"
        :show-close="true"
      >
        <input
          slot="header"
          v-model="searchQuery"
          type="text"
          class="form-control"
          id="inlineFormInputGroup"
          placeholder="SEARCH"
        />
      </modal> -->
      <!-- <base-dropdown
        tag="li"
        :menu-on-right="!$rtl.isRTL"
        title-tag="a"
        title-classes="nav-link"
        class="nav-item"
      >
        <template
          slot="title"
        >
          <div class="notification d-none d-lg-block d-xl-block"></div>
          <i class="tim-icons icon-sound-wave"></i>
          <p class="d-lg-none">New Notifications</p>
        </template>
        <li class="nav-link">
          <a href="#" class="nav-item dropdown-item"
            >Mike John responded to your email</a
          >
        </li>
        <li class="nav-link">
          <a href="#" class="nav-item dropdown-item">You have 5 more tasks</a>
        </li>
        <li class="nav-link">
          <a href="#" class="nav-item dropdown-item"
            >Your friend Michael is in town</a
          >
        </li>
        <li class="nav-link">
          <a href="#" class="nav-item dropdown-item">Another notification</a>
        </li>
        <li class="nav-link">
          <a href="#" class="nav-item dropdown-item">Another one</a>
        </li>
      </base-dropdown> -->
      <base-dropdown
        tag="li"
        :menu-on-right="!$rtl.isRTL"
        title-tag="a"
        class="nav-item"
        title-classes="nav-link"
        menu-classes="dropdown-navbar"
      >
        <template slot="title">
          <div class="photo mt-md-1"><img :src="user.photoURL" /></div>
          <b class="caret d-none d-lg-block d-xl-block"></b>
        </template>

        <router-link class="nav-link" tag="li" to="/pages/user">
          <a class="nav-item dropdown-item">
            <i class="tim-icons icon-single-02 mr-3"></i> Profil
          </a>
        </router-link>

        <div class="dropdown-divider"></div>
        <li class="nav-link">
          <a href="#" @click="logout()" class="nav-item dropdown-item">
            <i class="tim-icons icon-key-25 mr-3"></i> Se déconnecter</a
          >
        </li>
      </base-dropdown>
    </ul>
  </base-nav>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import { BaseNav, Modal } from "@/components";
import SidebarToggleButton from "./SidebarToggleButton";
import { mapGetters } from "vuex";
import { isFilterEnable } from "../../util/filterTools";

export default {
  components: {
    SidebarToggleButton,
    CollapseTransition,
    BaseNav,
    Modal
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      conf: "auth/conf",
      mode: "auth/mode"
    }),
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    isRTL() {
      return this.$rtl.isRTL;
    }
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: "",
      filterEnable: false
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logout");
    },
    changeMode(mode) {
      this.$store.dispatch("auth/changeMode", mode);
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    }
  },
  watch: {
    conf(newValue, oldValue) {
      this.filterEnable = isFilterEnable(newValue);
    }
  },
  mounted() {
    this.filterEnable = isFilterEnable(this.conf);
  }
};
</script>
<style scoped>
.top-navbar {
  top: 0px;
}
.new-badge {
  position: absolute;
  border-radius: 6px;
  padding: 1px 7px;
  color: white;
  top: 7px;
  right: 13px;
  font-size: 10px;
  text-align: center;
}
.bold {
  font-weight: bold;
}
</style>
